import * as CONST from "./actionTypes";

const { data, ...userSettings } = JSON.parse(
  localStorage.getItem("userSettings") || "{}",
)



const INIT_STATE = {
  error: "",
  loading: false,
  settingInfo: data || {},
  total: 0,
  AUDLoading: false,
  faqsListing:[],
  faqLoading: false,
  settingsLoading: false,


};

 /**
      * Used for handle the response of home page api's
      */


const Settings = (state = INIT_STATE, action) => {
  switch (action.type) {
    case CONST.GET_SETTINGS:
      return {
        ...state,
        loading: true,
        settingsLoading: true,

      };

    case CONST.GET_SETTINGS_SUCCESS:
      return {
        ...state,
        settingInfo: action.payload.data || {},
        total: action.payload.totalCount || 0,
        loading: false,
        settingsLoading: false,
        error: "",
      };

    case CONST.GET_SETTINGS_FAIL:
      return {
        ...state,
        settingInfo: {},
        loading: false,
        settingsLoading: false,
        error: "",
      };

      case CONST.GET_FAQS:
        return {
          ...state,
          faqLoading: true,
        };
  
      case CONST.GET_FAQS_SUCCESS:
        return {
          ...state,
          faqsListing: action.payload.data || [],
          total: action.payload.totalCount || 0,
          faqLoading: false,
          error: "",
        };
  
      case CONST.GET_FAQS_FAIL:
        return {
          ...state,
          faqsListing: [],
          faqLoading: false,
          error: "",
        };
  
  
    
    default:
      return state;
  }
};

export default Settings;
